import styled from "styled-components";
//import PorqueEscolher from "./PorqueEscolher";
import Banner from "./Banner";
import AreaAtuacao from "./AreaAtuacao";
// import PrincipaisServicos from "./PrincipaisServicos";
// import MapaLocal from "./MapaLocal";
// import Relato from "./Relato";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; // Garante que o container ocupe a largura total

  @media (max-width: 768px) {
    // Estilos para telas menores que 768px
    justify-content: space-around;
    padding: 0 10px; // Adiciona um pouco de espaço nas laterais em dispositivos móveis
  }
`

export default function PaginaInicial() {
    return (
        <>
            <Banner />
            
            <Container>
            <AreaAtuacao />
            <br />
                {/* <Relato />
                <PorqueEscolher />
                <PrincipaisServicos />  */}
                {/* <MapaLocal /> */}
            </Container >
        </>
    )
}
